<template>
  <div>
    <button class="btn btn-info m-2" @click="goBack">Back</button>

    <card class="card" title="Add Merchant's Agent">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6" v-if="auth.merchant !== null">
              <fg-input
                type="text"
                label="Office Name"
                placeholder="Office Name"
                :disabled="true"
                v-model="auth.merchant.merchantName"
              >
              </fg-input>
            </div>
            <div class="col-md-6" v-if="auth.merchant !== null">
              <fg-input
                type="text"
                label="Company Name"
                placeholder="Company Name"
                :disabled="true"
                v-model="auth.merchant.companyName"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model="agent.firstName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model="agent.lastName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Email"
                placeholder="Email"
                v-model="agent.email"
              >
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label for="dateOfBirth">Date of Birth</label>
              <br />
              <date-picker
                id="dateOfBirth"
                v-model="agent.dateOfBirth"
                :input-class="'form-control'"
                :editable="false"
              ></date-picker>
            </div>

            <div class="col-md-4">
              <label>Gender</label>
              <select
                class="form-control op-border"
                v-model="agent.gender"
                required
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="BVN"
                placeholder="BVN"
                v-model="agent.bvn"
                pattern="[0-9]*"
                @input="validateBvn"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Business Name"
                placeholder="Business Name"
                v-model="agent.businessName"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Address"
                placeholder="Address"
                v-model="agent.address"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="agent.phoneNumber"
                pattern="[0-9]*"
                @input="validateNumber()"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-md-4">
            <label>Country</label>
            <select
              class="form-control op-border"
              id="rate-type"
              v-model="agent.country"
              required
             
            >
              <option value="">country</option>
              <option
                v-for="(ct, index) in utils.countries"
                :key="index"
                :value="ct.code"
              >
                {{ ct.name }}
              </option>
            </select>
          </div> -->

            <div class="col-md-4">
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="agent.state"
                required
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Local Government</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="agent.localGovernment"
                required
              >
                <option value="">Select Local Government</option>
                <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                  {{ lg.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading"> Fetching Lga's </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 p-2">
              <fg-input
                type="text"
                label="Terminal Serial Number"
                placeholder="Terminal Serial Number"
                v-model="agent.terminalSerial"
              >
              </fg-input>
            </div>

            <div class="col-md-4 p-2">
              <fg-input
                type="password"
                label="Password"
                placeholder="Password"
                v-model="agent.password"
              >
              </fg-input>
            </div>
            <div class="col-md-4 p-2">
              <fg-input
                type="password"
                label="Password Confirmation"
                placeholder="Password Confirmation"
                v-model="agent.password_confirmation"
              >
              </fg-input>
            </div>
          </div>
          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Create Agent
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "../store/axios";
export default {
  components: { DatePicker },
  data() {
    return {
      agent: {
        businessName: "",
        email: "",
        address: "",
        phoneNumber: "",
        country: "",
        lastName: "",
        firstName: "",
        dateOfBirth: "",
        gender: "",
        state: "",
        localGovernment: "",
        password: "",
        password_confirmation: "",
        terminalSerial: "",
        _id: "",
        idCardImg: null,
        addressImg: null,
      },
      loading: {
        show: false,
      },
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions([
      "getStates",
      "getLgas",
      "getCountries",
      "getMerchant",
      "createMerchantAgent",
    ]),
    goBack() {
      window.history.back();
    },
    async submit() {
      this.$confirm("Create Agent?").then(() => {
        const data = {
          ...this.agent,
          merchantWalletId: this.auth.merchant.walletId,
          merchantId: this.auth.merchant._id,
        };
        this.createMerchantAgent(data);
      });
    },
    fetchLgas() {
      this.agent.lga = "";
      this.getLgas(this.agent.state);
    },
    handleIdCardUpload(event) {
      const file = event.target.files[0];
      this.agent.idCardImg = file;
    },
    handleAddressUpload(event) {
      const file = event.target.files[0];
      this.agent.addressImg = file;
    },
    submitKYC() {
      if (this.agent.idCardImg == null && this.agent.addressImgUrl == null) {
        this.$confirm("Upload all documents to proceed");
        return;
      }
      const formData = new FormData();
      formData.append("agentId", this.agent._id);
      formData.append("idCardImg", this.agent.idCardImg);
      formData.append("addressImg", this.agent.addressImg);
      this.loading.show = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/upload-agent-documents`,
          formData,
        )
        .then((response) => {
          this.$confirm("KYC Submitted Successfully");
          console.log(response.data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading.show = false;
        });
    },
    validateBvn() {
      // Remove non-numeric characters from the input value
      this.agent.bvn = this.agent.bvn.replace(/[^0-9]/g, "");
    },
    validateNumber() {
      // Remove non-numeric characters from the input value
      this.agent.phoneNumber = this.agent.phoneNumber.replace(/[^0-9]/g, "");
    },
  },
  mounted() {
    // this.getCountries();
    this.getStates();
    this.getMerchant(this.$route.params.merchantId);
  },
};
</script>
<style></style>
